import { createAsyncThunk } from '@reduxjs/toolkit'
import { ApiError, GetNoteCodeResponse } from '@user/store/leadNotes/typings'
import { get, put } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { DefaultNoteModel } from '@user/components/Settings/Notes/typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}`

export const getNoteCodes = createAsyncThunk<GetNoteCodeResponse>(
  '/Notes/noteCodes',
  async (_model, thunkApi) => {
    const response = await get(`${baseUrl}/Notes/noteCodes`)
    if (response.ok) return await response.json()
    return thunkApi.rejectWithValue((await response.json()) as ApiError)
  },
)
export const getNoteSettings = createAsyncThunk<DefaultNoteModel>(
  '/notesSettings',
  async (_model, thunkApi) => {
    const response = await get(`${baseUrl}/notesSettings`)
    if (response.ok) return await response.json()
    return thunkApi.rejectWithValue((await response.json()) as ApiError)
  },
)
export const saveNoteSettings = createAsyncThunk<
  DefaultNoteModel,
  DefaultNoteModel
>('/notesSettings', async (model, thunkApi) => {
  const response = await put(`${baseUrl}/notesSettings`, model)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue((await response.json()) as ApiError)
})
